import { create } from 'zustand';
import type { MeResponse } from '@formacion-docente/schemas';

export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'unauthenticated' | 'totp_required';

interface AuthState {
  user: MeResponse | null;
  status: AuthStatus;
  tempToken: string | null;
  setUser: (user: MeResponse | null) => void;
  setStatus: (status: AuthStatus) => void;
  setTotpRequired: (tempToken: string) => void;
  clear: () => void;
}

/**
 * Store de sesión. La cookie HttpOnly la maneja el backend; nosotros
 * sólo mantenemos el snapshot del usuario actual para gates RBAC y
 * renderizado del TopBar.
 */
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  tempToken: null,
  setUser: (user) => set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
  setTotpRequired: (tempToken) => set({ status: 'totp_required', tempToken }),
  clear: () => set({ user: null, status: 'unauthenticated', tempToken: null }),
}));